import { Route, Routes } from "react-router-dom";
import { NewLossReport } from "../pages/customers/NewLossReport";
import { TermsOfUse } from "../pages/termsofuse/TermsOfUse";
import { Privacy } from "../pages/privacy/Privacy";
import { Success } from "../pages/customers/Success";
import { Error } from "../pages/customers/Error";

export function PublicAccess() {
	return (
		<div className="container py-4">
			<div className="container col-12 col-md-7 col-lg-7">
				<Routes>
					<Route index path="/" element={<NewLossReport />} />
					<Route index path="/success" element={<Success />} />
					<Route index path="/error" element={<Error />} />
					<Route path="/terms" element={<TermsOfUse />} />
					<Route path="/privacy" element={<Privacy />} />
				</Routes>
			</div>
		</div>
	);
}
